// Base page type that all other page types will extend
export const BasePageType = {
	// Basic page structure
	getDefaultContent: () => ({
		layout: "default",
		settings: {
			showHeader: true,
			showFooter: true,
		},
		sections: [],
	}),

	// Common section types that can be used by any page
	sectionTypes: {
		header: {
			type: "header",
			getDefault: () => ({
				id: `header-${Date.now()}`,
				type: "header",
				name: "Header Section",
				isVisible: true,
				layout: "default",
				content: {},
				layers: [],
			}),
		},
		content: {
			type: "content",
			getDefault: () => ({
				id: `content-${Date.now()}`,
				type: "content",
				name: "Content Section",
				isVisible: true,
				layout: "default",
				content: {},
				layers: [],
			}),
		},
		footer: {
			type: "footer",
			getDefault: () => ({
				id: `footer-${Date.now()}`,
				type: "footer",
				name: "Footer Section",
				isVisible: true,
				layout: "default",
				content: {},
				layers: [],
			}),
		},
	},

	// Common layouts that can be used by any section
	layouts: {
		default: {
			name: "Default",
			description: "Standard layout with full width",
		},
		container: {
			name: "Container",
			description: "Centered content with max width",
		},
		grid: {
			name: "Grid",
			description: "Items arranged in a grid",
		},
		list: {
			name: "List",
			description: "Items stacked vertically",
		},
	},
};
